import CourseModules from "./CourseModules";

export default CourseModules;
